/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ea-location-label[_ngcontent-%COMP%]{line-height:30px}.ea-address[_ngcontent-%COMP%]{flex-grow:1}.ea-address-comment[_ngcontent-%COMP%]{max-width:160px}"];
export { styles as styles };
